import { couponCookie, ReferrerType } from '@farmersdog/coupons';

export function getPartnerTypePCode() {
  const { referrerCode, referrerType } = couponCookie.get();
  const pcode =
    referrerCode && referrerType === ReferrerType.Partner ? referrerCode : '';
  return pcode;
}
